/* eslint-disable no-unused-vars */
export const enum MedioDePago {
    MERCADOPAGO = "MERCADOPAGO",
    TRANSFERENCIA = "TRANSFERENCIA",
}
